/* Free-shipping progress bar (snippets/jc-cart-progress.liquid).
   Thresholds come in shop-currency cents; carts in another presentment currency are compared
   after converting the threshold with Shopify.currency.rate. Refreshes on the theme's cart events. */
(function () {
  if (customElements.get('jc-free-shipping')) return;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  class JcFreeShipping extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      document.addEventListener('cart:updated', this.refresh);
      // First paint comes from Liquid; only carts in another currency need the JS conversion.
      if (this.dataset.count !== undefined) {
        this.render({
          item_count: parseInt(this.dataset.count, 10) || 0,
          total_price: parseInt(this.dataset.total, 10) || 0,
          currency: this.dataset.currency,
        });
      } else {
        this.refresh();
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('cart:updated', this.refresh);
    }

    refresh(event) {
      const data = event && event.cartData;
      if (data && typeof data.item_count === 'number' && data.currency) return this.render(data);
      const request = window.jcGetCart
        ? window.jcGetCart()
        : fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
            headers: { Accept: 'application/json' },
          }).then((r) => r.json());
      request.then((cart) => this.render(cart)).catch(() => {});
    }

    render(cart) {
      const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      const threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
      if (!threshold || cart.item_count === 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      const total = cart.total_price;
      const remaining = threshold - total;
      const percent = Math.min(100, Math.floor((total * 100) / threshold));
      const text = this.querySelector('[data-text]');
      const track = this.querySelector('[role="progressbar"]');
      const fill = this.querySelector('.jc-ship__fill');
      if (remaining > 0) {
        text.textContent = this.dataset.msgRemaining.replace('[amount]', formatMoney(remaining, cart.currency));
        this.classList.remove('jc-ship--done');
      } else {
        text.textContent = this.dataset.msgReached;
        this.classList.add('jc-ship--done');
      }
      track.setAttribute('aria-valuenow', String(percent));
      // The drawer re-renders this element on every change: start from the last shown value so
      // the fill slides (CSS transition) instead of jumping.
      const last = window.jcShipPercent;
      window.jcShipPercent = percent;
      if (typeof last === 'number' && last !== percent && !this.dataset.animated) {
        fill.style.transition = 'none';
        fill.style.transform = 'translateX(' + (last - 100) + '%)';
        void fill.offsetWidth;
        fill.style.transition = '';
      }
      this.dataset.animated = '1';
      fill.style.transform = 'translateX(' + (percent - 100) + '%)';
    }
  }

  customElements.define('jc-free-shipping', JcFreeShipping);
})();
